export default "__VITE_ASSET__RSDX9gyB__"